module.exports = __webpack_public_path__ + "static/img/avatar-man.ff2b3b53.png";